module.exports = __webpack_public_path__ + "img/arrow_back_white.42b71eeb.svg";